export const sleep = async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

interface WithRetryProps<T> {
  fn: () => Promise<T>;
  errorCondition?: (error: Error) => boolean;
  delay: number;
  numRetries?: number;
}
export const withRetry = async <T>({
  fn,
  delay,
  errorCondition = () => true,
  numRetries = 15,
}: WithRetryProps<T>): Promise<T> => {
  let error;

  for (let i = 0; i < numRetries + 1; ++i) {
    try {
      return await fn();
    } catch (e) {
      if (e instanceof Error && errorCondition(e)) {
        error = e;
        await sleep(delay);
      } else {
        throw e;
      }
    }
  }

  throw error;
};

export class ConditionNotSatisfied extends Error {};

interface RetryUntilProps<T> {
  fn: () => Promise<T>;
  cond?: (v: T) => boolean;
  delay: number;
  numRetries?: number;
}

export const retryUntil = async <T>({
  fn,
  delay,
  cond = (v: T) => !!v,
  numRetries = 15,
}: RetryUntilProps<T>): Promise<T | null> => {
  let res: T | null = null;
  for (let i = 0; i < numRetries + 1; ++i) {
    try {
      res = await fn();
      if (cond(res)) {
        return res;
      }
    } catch (error) {
      console.error(error);
    }

    await sleep(delay);
  }

  throw new ConditionNotSatisfied();
};
